import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function Text() {
    return (
        <Container>
            <Row>
                <Col className="mt-5 text-center">
                    <h1>Місто в якому нема лиш мене</h1>
                    <p><strong>«Місто, в якому мене немає»</strong> - це захоплюючий японський аніме-серіал, створений за мотивами однойменного роману Кайо Хінадзуки. Головний герой, Сатору Фудзінума, молодий і замкнутий хлопець, має незвичайну здатність передбачати смерть людей, що оточують його.</p>

                    <p>Повсякчас його навідають кошмари, які пророкують неминучу загибель. Сатору намагається уникати біди та рятує людей від нещасних подій, випадкових аварій і вбивств. Проте його постійно супроводжує почуття самотності, так як він не може поділитися своїми спостереженнями з іншими.</p>

                    <p>Події серіалу розгортаються, коли Сатору зустрічає дівчину на ім'я Кайо Хінадзуки, яка також володіє схожою здатністю. Разом вони намагаються з'ясувати та пророзуміти таємницю цих загадкових передбачень смерті, що переслідують їх.</p>

                    <p>«Місто, в якому мене немає» - це захоплюючий трилер, який поєднує елементи детективу, містичного і драматичного жанрів. Серіал досліджує питання долі, взаємозв'язку між людьми і загрози, які нависають над ними. Кожен епізод наповнений напруженням, несподіваними поворотами сюжету та інтригуючими персонажами.</p>

                    <p>Анімація в серіалі виконана на високому рівні, з виразною графікою і деталізацією. Музичний супровід також додає настрою і підкреслює емоційну напруженість сцен.</p>

                    <p>«Місто, в якому мене немає» - це аніме, яке захопить вас своєю загадковістю, інтригою і величезною дозою суспільної напруги. Це залишить вас у напруженому очікуванні, бажаючи дізнатися більше про таємницю, що приховується за цими передбаченнями смерті.</p>






                </Col>
            </Row>
        </Container>
    );
}

export default Text;